import "./Refer.css";
import box from "../../../../assets/box.png";

const Refer = ({ setReferModal }) => {
 return (
  <div className="refer">
   <div className="desktop">
    <div className="refer-content">
     <div className="">
      <img src={box} alt="box" />
     </div>
     <div className="text-container">
      <p className="title">Get free N,1000</p>
      <p className="semi-bold">
       Refer a friend and be rewarded for each one who signs up and becomes an
       affiliate.
      </p>
     </div>
     <div className="">
      <p className="shapBtn" onClick={() => setReferModal(true)}>
       Refer a friend
      </p>
     </div>
    </div>
   </div>

   <div className="mobile">
    <div className="refer-content">
     <div className="img-container">
      <div>
       <img src={box} alt="box" />
      </div>
      <div>
       <p className="shapBtn" onClick={() => setReferModal(true)}>
        Refer a friend
       </p>
      </div>
     </div>
     <div className="text-container">
      <p className="title">Get free N,1000</p>
      <p className="semi-bold">
       Refer a friend and be rewarded for each one who signs up and becomes an
       affiliate.
      </p>
     </div>
    </div>
   </div>
  </div>
 );
};

export default Refer;
